/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable no-use-before-define */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
import $ from 'jquery';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import checkMetamask from '../../utils/checkMetamask';
import showAlert from '../../utils/showAlert';
import login from '../../utils/checkLogin';
import _t from '../../utils/translate';

const getContents = ({ contents, type, currentPrice }) => (
  {
    domain: {
      chainId: window.selectedChain === 'CHZ' ? window.signatureChainIdChz : window.signatureChainId,
      name: 'NftSoccerGames',
      verifyingContract: window.selectedChain === 'CHZ' ? window.contractAddressChz : window.contractAddress,
      version: '1',
    },

    // Defining the message signing data content.
    message: {
      contents,
      type,
      price: currentPrice,
    },
    // Refers to the keys of the *types* object below.
    primaryType: 'TrainingBuy',
    types: {
      EIP712Domain: [
        { name: 'name', type: 'string' },
        { name: 'version', type: 'string' },
        { name: 'chainId', type: 'uint256' },
        { name: 'verifyingContract', type: 'address' },
      ],
      TrainingBuy: [
        { name: 'type', type: 'uint256' },
        { name: 'price', type: 'uint256' },
      ],
    },
  }
);

const initBuyTrainingCenter = async () => {
  const marketplaceElements = $('.mintTrainingCenter');
  if (!marketplaceElements.length) {
    return;
  }

  marketplaceElements.on('click', async function (e) {

    const type = $(this).data('type');
    const message = $(this).data('message');
    const successRate = $(this).data('success-rate');
    const capacity = $(this).data('capacity');
    const $img = $(this).closest('.item-layer').find('img');
    const nextId = $(this).data('next-id');
    const currentPrice = $(this).data('price');



    Swal.fire({
      // title: 'Buy TrainingCenter',
      html: `
        <div class="text-center" style="margin-top: 30px; position: relative;">
          <div class="" style="position: absolute; top: 0; left: 0; right: 0; text-shadow: 1px 1px 1px #000; font-size: 20px;">Level: <span style="color: red;font-weight: bold;">${_t(type)}</span> <br /> Capacity: <span style="color: red;font-weight: bold;">${capacity}</span> <br /> ${successRate ? `Success Rate: <span style="color: red;font-weight: bold;">${successRate}</span> <br />` : ''} Price: <span style="color: red; font-weight: bold;">${currentPrice} NFSG</span></div>
          <img src="${$img.attr('src')}" style="margin-top: 30px" alt="" />
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: _t('Buy!'),
      showLoaderOnConfirm: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const x = await checkMetamask();

        if (x === false) {
          return false;
        }

        if (!await login()) {
          return;
        }

        const accounts = await window.web3.eth.getAccounts();
        showAlert({
          title: 'In Progress',
          message: 'Please wait while your transaction is in progress. You will be redirected to My Wallet page when the transaction succeeds.',
          icon: 'wait',
        });
        const contents = getContents({
          contents: '',
          type,
          currentPrice,
        });

        const msgParams = JSON.stringify(contents);
        const from = accounts[0];

        const params = [from, msgParams];
        const method = 'eth_signTypedData_v4';

        window.web3.currentProvider.sendAsync(
          {
            method,
            params,
            from,
          },
          (err, result) => {
            if (result.error) {
              Swal.fire(
                _t('Error!'),
                result.error.message,
                'error',
              );
            } else {
              const msgData = {
                address: accounts[0],
                message: msgParams,
                signature: result.result,
                type,
                price: currentPrice,
                sessionKey: window.sessionKey,

              };

              $.post({
                url: '/api/wallet/buyTrainingCenter',
                headers: {
                  token: window.token,
                },
                data: msgData,
                success: (data) => {
                  if (data.success) {
                    Swal.fire(
                      _t('Success!'),
                      data.message,
                      'success',
                    );

                    window.location = `/${data.training_center.seo}`;
                  } else {
                    Swal.fire(
                      _t('Error!'),
                      data.message,
                      'error',
                    );
                  }
                },
                error(xhr, status, error) {
                  // handle error
                },
              });
            }
          },
        );
      }
    });
  });
};

export default initBuyTrainingCenter;
